export default "__VITE_ASSET__BlGxDBzT__"